import { Period } from '@vy/types';
import { vyDate } from '@vy/utils';
import { BAR_HORIZONTAL_OFFSET, BAR_VERTICAL_OFFSET } from './contract-phases-timeline-consts';

type ContractPhasesDataRowPlacementContainerProps = {
  columnAmount: number;
  columnWidth: number;
  prePhasePeriod: Period;
  barHeight: number;
  basePlacementStartingPoint: number;
  barsGap: number;
  phaseIndex: number;
  children: (isDisplayingOffset: boolean) => React.ReactNode;
};

export const ContractPhasesDataRowPlacementContainer: React.FC<
  ContractPhasesDataRowPlacementContainerProps
> = ({
  barHeight,
  columnAmount,
  prePhasePeriod,
  barsGap,
  basePlacementStartingPoint,
  columnWidth,
  phaseIndex,
  children,
}) => {
  const containerWidth = columnWidth * columnAmount;

  const barStartRatio = calculatePhaseStartPositionRatio(prePhasePeriod, columnAmount);
  const baseStartPosition = basePlacementStartingPoint + barStartRatio * containerWidth;
  const startPositionWithOffset = baseStartPosition + BAR_HORIZONTAL_OFFSET;

  const shouldDisplayOffset = baseStartPosition === 0;
  const startPositionToUse = shouldDisplayOffset ? startPositionWithOffset : baseStartPosition;

  const baseRowHeight = barHeight + barsGap;
  const currentRowHeight = baseRowHeight * phaseIndex;
  const currentRowHeightWithOffset = currentRowHeight + BAR_VERTICAL_OFFSET;

  return (
    <div
      style={{
        top: `${currentRowHeightWithOffset}px`,
        left: `${startPositionToUse}px`,
      }}
      className="absolute"
    >
      {children(shouldDisplayOffset)}
    </div>
  );
};

function calculatePhaseStartPositionRatio(prePhasePeriod: Period, columnAmount: number): number {
  const phaseDays = vyDate(prePhasePeriod.endTime).diff(vyDate(prePhasePeriod.startTime), 'months', true);

  return phaseDays / columnAmount;
}
